import { useState } from 'react';

export default function Thanks2026lms3dayme1Page() {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText('https://zoom.us/j/99852750662');
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: 'linear-gradient(160deg, #faf7ff 0%, #f3eeff 40%, #eef8f6 100%)' }}>

      {/* 星空背景 */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(50)].map((_, i) => {
          const sizes = [0.8, 1, 1.2, 1.5, 1.8, 2];
          const size = sizes[i % sizes.length];
          const lefts = [3,8,14,19,25,31,37,42,48,53,59,64,70,75,81,86,92,97,5,11,17,23,29,35,41,47,55,61,67,73,79,85,91,96,2,9,16,22,28,34,40,46,52,58,65,71,77,83,89,95];
          const tops = [5,12,18,24,30,36,42,48,54,60,66,72,78,84,90,7,13,19,25,31,37,43,49,55,61,67,73,79,85,91,3,10,16,22,28,34,40,46,52,58,64,70,76,82,88,94,8,15,21,27];
          const delays = [0,0.5,1,1.5,2,2.5,3,3.5,0.2,0.7,1.2,1.7,2.2,2.7,3.2,0.4,0.9,1.4,1.9,2.4,2.9,3.4,0.1,0.6,1.1,1.6,2.1,2.6,3.1,3.6,0.3,0.8,1.3,1.8,2.3,2.8,3.3,3.8,0.05,0.55,1.05,1.55,2.05,2.55,3.05,3.55,0.15,0.65,1.15,1.65];
          const durations = [2,2.5,3,3.5,4,2.2,2.7,3.2,3.7,2.4,2.9,3.4,2.1,2.6,3.1,3.6,2.3,2.8,3.3,3.8,2.0,2.5,3.0,3.5,4.0,2.2,2.7,3.2,3.7,4.2,2.4,2.9,3.4,3.9,2.1,2.6,3.1,3.6,2.3,2.8,3.3,3.8,2.0,2.5,3.0,3.5,4.0,2.2,2.7,3.2];
          return (
            <div
              key={i}
              className="absolute rounded-full"
              style={{
                width: `${size}px`,
                height: `${size}px`,
                left: `${lefts[i]}%`,
                top: `${tops[i]}%`,
                background: `rgba(160, 120, 220, 0.35)`,
                animation: `twinkle ${durations[i]}s ease-in-out infinite`,
                animationDelay: `${delays[i]}s`,
              }}
            />
          );
        })}
      </div>

      {/* 光のオーブ */}
      <div className="absolute top-20 left-1/4 w-96 h-96 rounded-full pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(160,120,240,0.1) 0%, transparent 70%)' }}></div>
      <div className="absolute bottom-40 right-1/4 w-80 h-80 rounded-full pointer-events-none" style={{ background: 'radial-gradient(ellipse, rgba(60,180,160,0.08) 0%, transparent 70%)' }}></div>

      <div className="relative z-10 w-full">

        {/* 画像：全幅表示 */}
        <div className="w-full">
          <a
            href="https://liff.line.me/2006804245-oakZeLjM/landing?follow=%40954vrmxf&lp=J1sQJ5&liff_id=2006804245-oakZeLjM"
          >
            <img
              src="https://static.readdy.ai/image/df6191d64b069156d892c30ff01b3198/47a71d13ef301fb8d49461ad802afc64.jpeg"
              alt="ハイヤーセルフ覚醒セレモニー"
              className="w-full h-auto object-top block cursor-pointer"
              style={{ maxWidth: '100%', margin: '0 auto', display: 'block' }}
            />
          </a>
        </div>

        {/* LINE登録ボタン */}
        <div className="px-3 py-4 sm:px-4 sm:py-6" style={{ maxWidth: '100%', margin: '0 auto' }}>
          <a
            href="https://liff.line.me/2006804245-oakZeLjM/landing?follow=%40954vrmxf&lp=J1sQJ5&liff_id=2006804245-oakZeLjM"
            className="w-full py-5 rounded-xl font-bold text-lg flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap transition-all hover:opacity-90"
            style={{
              background: 'linear-gradient(135deg, #06C755, #00B548)',
              color: '#ffffff',
              letterSpacing: '0.1em',
              boxShadow: '0 4px 20px rgba(6,199,85,0.35)',
              textDecoration: 'none',
            }}
          >
            <i className="ri-line-fill text-2xl"></i>
            LINEに登録する
          </a>
        </div>

      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Noto+Serif+JP:wght@400;500;600;700&display=swap');
        @keyframes twinkle {
          0%, 100% { opacity: 0.15; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.4); }
        }
      `}</style>
    </div>
  );
}
